<particle-treaty-document
        [isShowBreadcrumbs] = false
        [isShowActionItems] = false
        [handler]="handler"
></particle-treaty-document>
